module.exports = __webpack_public_path__ + "img/d6.543db09f.jpg";